module.exports = __webpack_public_path__ + "img/paysafecard.7d6e2a5d.svg";